import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { mainFont } from '../../theme';
import Typewriter, { TypewriterClass } from 'typewriter-effect';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
	root: {
		textAlign: 'center',
		fontFamily: mainFont,
		fontSize: '30px',
		height: '200px',
	},
	"@media (max-width: 700px)": {
		root: {
			fontSize: '22px'
		}
	}
});

const handleWelcome = (typewriter: TypewriterClass) => {
	typewriter
		.changeDelay(70)
		.pauseFor(1500)
		.typeString('Welcome to COSINT')
		.pauseFor(4000)
		.changeDeleteSpeed(50)
		.deleteAll()
		.pauseFor(500)
		.changeDelay(60)
		.typeString(
			'The Official collaborative OSINT platform designed to stop the spread of misinformation online'
		)
		.pauseFor(3000)
		.changeDelay(100)
		.typeString(
			'... with your help'
		)
		.pauseFor(7000)
		.changeDeleteSpeed(20)
		.deleteAll()
		.start();
};

function About() {
	const classes = useStyles();

	return (
		<>
			<Box className={classes.root}>
				<Typewriter
					onInit={handleWelcome}
					options={{
						// strings: ['Hello', 'World'],
						cursor: '|',
						autoStart: true,
						loop: true,
					}}
				/>
			</Box>
		</>
	);
}

export default About;
